import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { GuardProps, UserRole } from 'model/types/auth';

import useAuth from 'hooks/useAuth';

import { APP_DEFAULT_PATH } from 'constants/appConstants';

type RoleFlagGuardProps = GuardProps & {
  accessCondition?: boolean;
  requiredFlag?: string;
  requiredUserRoles?: UserRole[];
  shouldNavigate?: boolean;
};

export default function RoleFlagGuard({
  children,
  accessCondition,
  requiredFlag,
  requiredUserRoles,
  shouldNavigate = true
}: RoleFlagGuardProps) {
  const { flags, userRole } = useAuth();
  const navigate = useNavigate();

  const flagIsNotEnabled = requiredFlag && !flags?.includes(requiredFlag);
  const userRoleIsNotInRequiredRoles = requiredUserRoles && userRole && !requiredUserRoles.includes(userRole);
  const accessConditionNotMet = accessCondition === false;

  useEffect(() => {
    if (shouldNavigate && (flagIsNotEnabled || userRoleIsNotInRequiredRoles || accessConditionNotMet)) {
      navigate(APP_DEFAULT_PATH, {
        replace: true
      });
    }
  }, [flags, navigate, flagIsNotEnabled, userRoleIsNotInRequiredRoles, shouldNavigate, accessConditionNotMet]);

  if (flagIsNotEnabled || userRoleIsNotInRequiredRoles || accessConditionNotMet) {
    return null;
  }

  return children;
}
